<template>
  <div class="news-topic-list">
      <!-- <newsHeader :page="'专题新闻'"></newsHeader> -->
      <!-- <breadCrumb></breadCrumb> -->
      <div class="topic-list-wrapper flex-between main">
          <div class="topic-left-list">
            <div class="subtitle flex-align-between">
                  <!-- <h2 class="text text-first f16 flex-align">{{lists.name}}</h2> -->
            </div>
            <ul class="lists">
                <li class="flex-align" v-for="(li, index) in lists" :key="index" @click="toPage(li)">
                <div class="day f12 flex-column">
                    <span class="f28">{{handleTime(li.updateTime,'day')}}</span><span>{{handleTime(li.updateTime,'month')}}</span>
                </div>
                <div class="describe">
                    <h3 class="title wes f18">{{li.title}}</h3>
                    <p class="f12">{{li.introduction}}</p>
                    <!-- <span class="eye">{{li.lookNum}}</span> -->
                </div>
                </li>
            </ul>
            <div class="loading">
                <button class="load-more" @click="getNewsList()" :class="[loadClass?'load-more':'load-more-none']">{{loadText}}</button>                  
            </div>
          </div>
          <div class="topic-right-list">
            <div class="subtitle flex-align-between">
                  <h2 class="text text-first f16 flex-align">其他专题</h2>
            </div>
            <ul class="side-bar-list" ><!-- 专题新闻 -->
                <li v-for="(news, index) in otherTopicList" :key="index">
                    <h3 class="f16">{{news.name}}</h3>
                    <p>{{news.description}}</p>
                    <div class="other flex-align-between">
                        <span class="time">{{news.createTime}}</span>
                        <span class="eye">{{news.views}}</span>
                    </div>
                </li>
            </ul>
            <!-- <div class="loading">
                <button class="load-more" @click="getNewsList()" :class="[loadClass?'load-more':'load-more-none']">{{loadText}}</button>                  
            </div> -->
          </div>
      </div>
     <!-- <footer-view></footer-view> -->
  </div>
</template>

<script>
export default {
    data() {
        return {
            currentPage:1,
            loadText:'加载更多',
            loadClass:true,
            otherTopicList:[{
                name:'抗击疫情，网络云课程',
                description:'7月17日，由宁在全国上下共同抗击新型冠状病毒肺炎期间，为进一步做好服务保障防控疫情期间中小学校“停课不停教、停课...',
                createTime:'2020.06.21',
                views:1757,
            },{
                name:'抗击疫情，网络云课程',
                description:'7月17日，由宁在全国上下共同抗击新型冠状病毒肺炎期间，为进一步做好服务保障防控疫情期间中小学校“停课不停教、停课...',
                createTime:'2020.06.21',
                views:1757,
            }],
            lists:[]
        }
    },
    methods:{
        async getNewsList(){
            let that = this;
            let params = {
               id:that.$route.params.id,
               isAsc:'desc',
               pageNum:this.currentPage++,
               pageSize: 6,
            }            
            let resData = await Api.News.GetTopicNews(params)
            console.log(resData);
            // that.lists = resData.data;

            params.pageNum = this.currentPage;
            let res = await Api.News.GetTopicNews(params)
            if(res.rows.length < 1) {
                this.loadText = '加载已完成'
                this.loadClass = false;
            }
            
            that.lists = this.lists.concat(resData.rows);

         },

         async getTopicList(){
            let that = this;
            let arr =[];
            
            let params = {
                isAsc:'desc',
                pageNum:1,
                pageSize: 12
            }            
            let resData = await Api.News.GetTopicList(params)
            //console.log(resData.rows);
            
            if(resData.rows.length >= that.lists.news.length) {
                arr = that.lists.news 
            } else {
                arr = resData.rows
            }
            //  for(let i = 0; i < resData.rows.length; i++) {
            //      for(let j = 0; j < that.lists.news.length; j++) {
            //          if(resData.rows[i].id === that.lists.news[i].id) {
            //              resData.rows.splice(i,1);
            //          }
            //      }
            //  }
            for(let i = 0; i <arr.length; i++) {
                if(resData.rows[i].id === that.lists.news[i].id) {
                    resData.rows.splice(i,1);
                }
            }
            that.otherTopicList = resData.rows;
         },

         handleTime(time,type){
             if(type === 'day') {
                return Common.handleTimeFour(time)
             } else if (type === 'month') {
                var month =  Common.handleTimeThree(time)
                month = Common.transformEnglish(month)
                return month
             }
         },

         toPage(item) {
             console.log(item);
             let query = {
                 topic:this.$route.params.id
             }
             Common.goPage('/news/topic/detail/'+ item.id,this, query)
         },
    },
    mounted(){
         this.getNewsList()
        //  this.getTopicList();
    }
}
</script>

<style lang="less">
    @import "../less/news_topic_list.less";
</style>